import "../../styles/all.css"
import "../../styles/theme.css"
import "./chart.css"
import Chartone from "../draw/one"
function Chart(){
    return(
        <>
        <div className="chart" style={{marginTop:"120px"}}>
            <div className="frist">
                <h4>Payment Record</h4>
               <i className="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div className="draw">
                <Chartone/>

            </div>
            <div className="boxes">
                <div className="row">
                    <div className="col-md-3">
                        <div className="box">
                            <h4>Awaiting</h4>
                            <h5>$5,486</h5>
                            <div className="progress">
                                <div style={{backgroundColor:"green"}}></div>
                            </div>
                        </div>
                    </div>
                     <div className="col-md-3">
                        <div className="box">
                            <h4>Completed</h4>
                            <h5>$9,257</h5>
                            <div className="progress">
                                <div style={{backgroundColor:"blue"}}></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">

                        <div className="box">
                            <h4>Rejected</h4>
                            <h5>$3,868</h5>
                            <div className="progress">
                                <div style={{backgroundColor:"red"}}></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="box">
                            <h4>Revenue</h4>
                            <h5>$50,668</h5>
                            <div className="progress">
                                <div style={{backgroundColor:"gold"}}></div>
                            </div>
                        </div>
                    </div>
                </div>
                

            </div>
        </div>
        </>
    )

}
export default Chart